import YouTubeAPI from 'simple-youtube-api';

export function getYouTubeAPIClient () {
  return new YouTubeAPI('AIzaSyDWrCq5KcdfCxd8-oeyrJOg7uc41JPJUQQ');
}
